import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as _ from 'lodash';

import {EntitiesService} from '../../services/entitiesService.service';
import {ActivityLog} from '../../../main/models/activity-log';
import {ErrorHandlerService} from '../../services/error-handler.service';

@Component({
  selector: 'app-list-activity-log',
  templateUrl: './list-activity-log.component.html',
  styleUrls: ['./list-activity-log.component.css']
})
export class ListActivityLogComponent implements OnInit {

  @Input('targetedType') targetedType: 'project' | 'partner' | 'customer' | 'user';
  @Input('targetId') targetId: string;

  @Output() editActivity: EventEmitter<ActivityLog> = new EventEmitter();
  @Output() emitLoadedActivities: EventEmitter<ActivityLog[]> = new EventEmitter();

  activityLogs: {
    value: ActivityLog[],
    key: string,
    statistics: any;
  }[];

  hideDialogBox = true;
  itemToRemove: ActivityLog;
  confirmMsg = 'Are you sure you want to activity log?';
  selectedActivityType: string;

  constructor(
    private entitiesService: EntitiesService,
    private handler: ErrorHandlerService,
  ) { }

  ngOnInit() {
    this.getActivityLog();
  }

  getActivityLog() {
    this.entitiesService.getActivityLogFor(this.targetedType, this.targetId).subscribe(res => {
      this.activityLogs = _.chain(res.data)
        .groupBy('type')
        .reduce((result, value, key) => {
          if (key === 'done') {
            result[key] = _.orderBy(value, ['completionDate'], ['desc']);
          } else {
            result[key] = _.orderBy(value, ['dueDate'], ['asc']);
          }

          return result;
        }, {})
        .map((value, key) => ({
          key,
          value,
          statistics: _.groupBy(value, 'activityType.name'),
        }))
        .reverse()
        .value();

      this.emitLoadedActivities.emit(res.data);
    });
  }

  remove(item) {
    this.itemToRemove = item;
    this.hideDialogBox = false;
  }

  confirmRemove(result: boolean) {
    this.hideDialogBox = true;
    this.confirmMsg = '';
    if (!result) {
      return;
    }

    const id = this.itemToRemove._id;

    this.entitiesService.deleteActivityLog(id).subscribe(
      () => this.getActivityLog(),
      err => this.handler.handle(err),
    );
  }

  markLogAsDone(log: ActivityLog) {
    this.entitiesService.markLogAsDone(log._id).subscribe(() => {
      this.getActivityLog();
    });
  }

  onEditActivity(log: ActivityLog) {
    this.editActivity.emit(log);
  }
}
